export default "__VITE_ASSET__CivJZ8f1__"